import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Form,
  Row,
  Input,
  Col,
  Card,
  Table,
  Grid,
  Spin,
  Button,
  Space,
} from "antd";

//import { Input as InputDsGov, Button, Group, Card as CardDsGov, Row, Col as ColDsgov } from "react-dsgov";

import { ExpandAltOutlined, EditOutlined, ClearOutlined, SearchOutlined } from "@ant-design/icons";
import type { AlignType } from 'rc-table/lib/interface';

import { maskCnpj, maskNumeroProcesso, numberOnly } from "../../../utils/maskFunctions";

import { useNavigate } from "react-router-dom";
import { errorMessage, infoMessage, mostrarInfo, mostrarInfoDetail } from "../../../messages/messages";
import type { IPessoaJuridica } from "../../../components/Interfaces";
import api, { type IErroApi } from "../../../services/api";
import { hasAnyPermissao, hasPermissao, Papel } from "../../../components/auth/entidadeUsuario";
import { pushToBase } from "../../../utils/utilsFunctions";


const { useBreakpoint } = Grid;

const Consultar: React.FC<any> = () => {

  const navigate = useNavigate();

  const [form] = Form.useForm();

  const screens = useBreakpoint();

  const { tipo } = useParams();

  const [pessoasJuridicas, setPessoasJuridicas] = useState<IPessoaJuridica[]>([]);
  const [pessoaJuridica, setPessoaJuridica] = useState<IPessoaJuridica>();
  const [pessoaJuridicaSelecionadaParaOperacao, setPessoaJuridicaSelecionadaParaOperacao] = useState<IPessoaJuridica>();

  const [totalElements, setTotalElements] = useState(0);
  const [linhaPorPagina, setLinhaPorPagina] = useState(10);
  const [pagina, setPagina] = useState(1);

  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");
  const [tipoConsulta, setTipoConsulta] = useState("");

  const [manter, setManter] = useState(2); // ESTADOS PARA PASSAR PARA A TELA SEGUINTE - 2 : Detalhar / 3 : Alterar; 

  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")
  const [erroApi, setErroApi] = useState<IErroApi>()


  useEffect(() => {
    window.scrollTo(0, 0)
    if (!hasAnyPermissao())
      pushToBase(navigate);
  }, []);

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi])

  useEffect(() => {
    window.scrollTo(0, 0)
    if (tipo)
      setTipoConsulta(tipo)
    else
      setTipoConsulta("");
    limparConsulta();
  }, [tipo]);

  useEffect(() => {
    if (pessoaJuridica) pushToManter(pessoaJuridica, manter);
  }, [pessoaJuridica]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (pessoaJuridicaSelecionadaParaOperacao) pushToPessoaJuridicaOperacoes();
  }, [pessoaJuridicaSelecionadaParaOperacao]); // eslint-disable-line react-hooks/exhaustive-deps

  function pushToManter(pj: any, manter: number) {
    let tpSelecao = {
      manter: manter,
      data: pj
    };

    navigate("/" + import.meta.env.VITE_APP_BASE + "/pessoa-juridica-manter", { state: tpSelecao });
  }

  function pushToPessoaJuridicaOperacoes() {
    let tpSelecao = {
      data: pessoaJuridicaSelecionadaParaOperacao,
    };

    navigate("/" + import.meta.env.VITE_APP_BASE + "/operacao-pessoa-juridica", { state: tpSelecao });
  }

  function gerarColunas() {
    let cols: any[] = [];

    cols.push({
      // key: "cnpj",
      width: 150,
      title: "CNPJ",
      dataIndex: "",
      render: (pj: IPessoaJuridica) => (
        <Input
          value={pj.tipoIdentificador === 1 ? maskCnpj(pj.numero) : undefined}
          size={"small"}
          style={{ padding: 0 }}
          variant="borderless"
        />
      ),
    });

    cols.push({
      // key: "tipoIdentificador",
      width: 150,
      title: "Número de Identificação Fiscal",
      dataIndex: "",
      render: (pj: IPessoaJuridica) => (
        <Input
          value={pj.tipoIdentificador === 2 ? pj.numero : undefined}
          size={"small"}
          style={{ padding: 0 }}
          variant="borderless"
        />
      ),
    });

    cols.push(
      screens.xs
        ? null
        :
        {
          // key: "numeroProcesso",
          width: 150,
          title: "Número Processo",
          dataIndex: "",
          render: (pj: IPessoaJuridica) => (
            <Input
              value={pj.numeroProcesso ? maskNumeroProcesso(pj.numeroProcesso) : undefined}
              size={"small"}
              style={{ padding: 0 }}
              variant="borderless"
            />
          ),
        }

    );

    cols.push({
      // key: "razaoSocial",
      // width: 400,
      title: "Nome Empressarial",
      dataIndex: "razaoSocial",
      width: screens.xs ? 400 : screens.xl ? 300 : 200,
    });

    cols.push({
      // key: "opcoes",
      width: 80,
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (pj: IPessoaJuridica) => (
        <>
          <SearchOutlined style={{ color: "blue", display: tipoConsulta === "" ? "none" : "inline" }}
            title="Operações"
            id='detalharOperacaoAutorizacao'
            onClick={() => {
              if (pj.serie) {
                setPessoaJuridicaSelecionadaParaOperacao(pj);
              }
              else {
                errorMessage("Série da Pessoa Jurídica não localizada.");
              }
            }}
          />

          <ExpandAltOutlined style={{ color: "blue", display: tipoConsulta === "" ? "inline" : "none" }}
            title="Detalhar"
            id='detalhar'
            onClick={() => {
              setManter(2);
              setPessoaJuridica(pj);
              // getPessoaJuridicaUltimoPorNumeroTipoIdentificador(pj.numero, pj.tipoIdentificador)
              // getPessoaJuridicaPorId(pj.id);
            }}
          />

          <EditOutlined style={{ color: "blue", display: tipoConsulta === "" && hasPermissao([Papel.DILIC_MASTER]) ? "inline" : "none" }}
            title="Versionar"
            id='versionar'
            onClick={() => {
              setManter(3);
              setPessoaJuridica(pj);
              // getPessoaJuridicaUltimoPorNumeroTipoIdentificador(pj.numero, pj.tipoIdentificador)
              // getPessoaJuridicaPorId(pj.id);
            }} />
        </>
      ),
    });
    return cols.filter(Boolean);
  }

  const columns = gerarColunas();

  const validarConsulta = () => {
    const currentForm = form.getFieldsValue();
    if ((currentForm?.cnpjNumero && currentForm?.cnpjNumero !== "") && (currentForm?.numeroIdentificacaoFiscal && currentForm?.numeroIdentificacaoFiscal !== "")) {
      errorMessage("Os campos CNPJ e Número de Identificação Fiscal foram preenchidos. A consulta não pode ser feita com ambos os campos preenchidos.");
    } else {
      getPessoasJuridicas();
    }
  };

  const getPessoasJuridicas = async () => {
    setLoading(true);
    setTipLoading("Pesquisando ...");

    const currentForm = form.getFieldsValue();

    const numero = currentForm?.cnpjNumero && currentForm?.cnpjNumero !== "" ? numberOnly(currentForm?.cnpjNumero) : (currentForm?.numeroIdentificacaoFiscal ? numberOnly(currentForm?.numeroIdentificacaoFiscal) : "")
    const razaoSocial = currentForm.razaoSocial || "";
    const numeroProcesso = numberOnly(currentForm.numeroProcesso) || "";

    let lQuery = `consulta/dinamica?numero=${numero}&razao-social=${razaoSocial}&numero-processo=${numeroProcesso}&page-size=${linhaPorPagina}&page=0`;
    await api.get(lQuery).then((response) => {
      //console.log(response);
      //console.log(response.status);

      setPessoasJuridicas(response.data.content);
      setTotalElements(response.data.totalElements);
      if (response.data.content.length === 0) {
        infoMessage("O sistema não encontrou resultado para consulta realizada");
      }
      setLoading(false);
    })
      .catch(error => {
        let data: IErroApi = error.response.data;
        let msgErro = data.mensagem ? data.mensagem : error.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(error.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (error.response.status < 500) {
          setErroApi(data);
        } else {
          if (error.response.status === 503)
            errorMessage("Servidor remoto não disponível");
          else
            errorMessage(msgErro);
        }
        setLoading(false);
      });
  };

  const handlePaginationChange = async (page: number, pageSize: number) => {
    setLoading(true);

    setPagina(page);
    setLinhaPorPagina(pageSize);

    const numero = numberOnly(form.getFieldValue("numero")) || "";
    const razaoSocial = form.getFieldValue("razaoSocial") || "";
    const numeroProcesso = numberOnly(form.getFieldValue("numeroProcesso")) || "";
    try {
      let lQuery = `consulta/dinamica?numero=${numero}&razao-social=${razaoSocial}&numero-processo=${numeroProcesso}&page-size=${pageSize}&page=${page - 1}`;

      const { data } = await api.get(lQuery);

      setPessoasJuridicas(data.content);
      setLoading(false);
    } catch (error: any) {
      //console.log(error);
      let data: IErroApi = error.response.data;
      let msgErro = data.mensagem ? data.mensagem : error.response.data.message;
      let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
      setEstadoErroApi(error.response.status);
      setMsgErroApi(msgErro + msgDetalheErro);
      if (error.response.status < 500) {
        setErroApi(data);
      } else {
        if (error.response.status === 503)
          errorMessage("Servidor remoto não disponível");
        else
          errorMessage(msgErro);
      }
      setLoading(false);
    }
  };

  function limparConsulta() {
    setPessoasJuridicas([]);
    setPessoaJuridica(undefined);
    setTotalElements(0);
    form.resetFields();
  }

  return (
    <Spin spinning={loading} tip={tipLoading}>

      <h1>{tipoConsulta === "" ? "Consultar Pessoa Jurídica" : "Consultar Pessoa Jurídica - Operações"}</h1>

      <Card>
        <Form layout="vertical" form={form}>
          <Row>
            <Col xs={24} xl={7}>
              <Form.Item
                label="CNPJ"
                name='cnpjNumero'
              >
                <Input maxLength={18}
                  onChange={(e) =>
                    form.setFieldsValue({
                      cnpjNumero: maskCnpj(e.target.value),
                    })
                  }
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={7}>
              <Form.Item
                label="Número de Identificação Fiscal (NIF)"
                name='numeroIdentificacaoFiscal'
              >
                <Input
                  maxLength={21}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={7}>
              <Form.Item
                label="Número do Processo"
                name='numeroProcesso'
              >
                <Input
                  maxLength={21}
                  onChange={(e) =>
                    form.setFieldsValue({
                      numeroProcesso: maskNumeroProcesso(e.target.value),
                    })
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={16}>
              <Form.Item label="Nome Empresarial"
                name='razaoSocial'
              >
                <Input
                  id="razaoSocial"
                  placeholder="Digitar o nome"
                  onChange={(e) =>
                    form.setFieldsValue({
                      razaoSocial: e.target.value.toUpperCase(),
                    })
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="end">
            <Space align='center' >
              {
                <>
                  <Button shape='round' type='primary' icon={<SearchOutlined />} htmlType='button'
                    onClick={() => {
                      validarConsulta();
                    }} >
                    Consultar
                  </Button>
                  <Button disabled={false} shape='round' icon={<ClearOutlined />} htmlType='button'
                    onClick={() => {
                      limparConsulta();
                      window.scrollTo(0, 0)
                    }} >
                    Limpar
                  </Button>
                </>
              }
            </Space>
          </Row>


        </Form>
      </Card>

      <Card title={"Resultado da consulta - " + totalElements + " encontrados"} style={{ display: totalElements === 0 ? 'none' : 'inline' }}>
        <Table
          // className="overflowConsulta"
          dataSource={pessoasJuridicas}
          size="middle"
          columns={columns}
          rowKey="serie"
          loading={loading}
          pagination={{
            current: pagina,
            pageSize: linhaPorPagina,
            total: totalElements,
            showSizeChanger: true,
            onChange: handlePaginationChange,
            pageSizeOptions: ["10", "20", "25", "30"],
            locale: { items_per_page: "Linhas por página" },
          }}
          scroll={{ x: "max-content", y: 350 }}
        />
      </Card>

    </Spin >
  );
};

export default Consultar;
